import { DbtResourceType, ModelType } from '../types';
import { ReactComponent as PipelineIcon } from '../assets/16x16/pipeline.svg';
import { ReactComponent as TableIcon } from '../assets/16x16/table.svg';
import { ReactComponent as ColumnIcon } from '../assets/columns.svg';

export const getReportAssetType = ({
  artifact_type,
  meta,
  type,
}: {
  artifact_type: DbtResourceType;
  meta?: Record<string, any>;
  type?: ModelType;
}) => {
  if (artifact_type === 'exposure') {
    return meta?.sub_type || type;
  }
  return artifact_type;
};

export const getAssetIcon = (asset: { __typename: string }): JSX.Element => {
  switch (asset.__typename) {
    case 'EtlAsset':
      return <PipelineIcon />;
    case 'TableAsset':
      return <TableIcon />;
    case 'ColumnAsset':
      return <ColumnIcon />;
    default:
      return <TableIcon />;
  }
};
